import { IsString, MaxLength, IsOptional, IsInt, IsBoolean } from 'class-validator';

export class NotificationSearchDTO {

    @IsOptional()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsInt()
    entity: number;

    @IsOptional()
    @IsInt()
    event: number;

    @IsOptional()
    @IsInt()
    type: number;

    @IsOptional()
    @IsBoolean()
    active: boolean;

}
